import { z } from "zod";
import { type MeditationDailyWithoutId } from "../../firestore";

export const MeditationServerSchema = z.object({
  slug: z.string().min(1),
});

export type MeditationServerQueryParams = z.infer<typeof MeditationServerSchema>;

export const MeditationsServerSchema = z.object({
  limit: z
    .string()
    .refine(
      (val) => {
        const num = Number(val);
        return Number.isInteger(num) && num >= 1 && num <= 50;
      },
      {
        message: "limit must be a string representing an integer between 1 and 50",
      },
    )
    .optional(),
  page: z
    .string()
    .refine(
      (val) => {
        const num = Number(val);
        return Number.isInteger(num) && num >= 1;
      },
      {
        message: "page must be a string representing a positive integer",
      },
    )
    .optional(),
  startAfterDateTimestamp: z.string().optional(),
  authorSlug: z.string().optional(),
});

export type MeditationsServerQueryParams = z.infer<typeof MeditationsServerSchema>;

// Transformed meditation
export type MeditationServerItemWithImageUrl = Omit<
  MeditationDailyWithoutId,
  "date" | "created_on" | "updated_on" | "author"
> & {
  id: string;
  authorId: string;
  imageUrl: string;
  dateMillis: number;
  createdOnMillis: number;
  updatedOnMillis: number;
};

export type MeditationServerResponse = MeditationServerItemWithImageUrl;

export interface MeditationsServerResponse {
  meditations: MeditationServerResponse[];
  pagination: {
    hasMore: boolean;
    startAfterDateTimestamp?: string;
    totalCount?: number;
  };
}
